import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Hidden } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import TitlePage from '../../components/titlePage/TitlePage';

// componet
// style
// import { globalStyle } from '../../global/style';

// img
import AboutOfficeImg from '../../assets/images/building.png';
import NwccBanner from '../../assets/images/nwcc.png';

// const useStyles = makeStyles(globalStyle);

const useStyles = makeStyles((theme) => ({
  // ...globalStyle,

  ntwIframe: {
    border: 0,
    height: '450px', // Default height for extra-small (XS) screens
    [theme.breakpoints.up('sm')]: {
      height: '800px', // Height for small (sm) screens and up
    },
    [theme.breakpoints.up('md')]: {
      height: '1500px', // Height for medium (md) screens and up
    },
  },
  basinIframe: {
    border: 0,
    height: '750px', // Default height for extra-small (XS) screens
    [theme.breakpoints.up('sm')]: {
      height: '1300px', // Height for small (sm) screens and up
    },
    [theme.breakpoints.up('md')]: {
      height: '2700px', // Height for medium (md) screens and up
    },
  },
  pwicIframe: {
    border: 0,
    height: '600px', // Default height for extra-small (XS) screens
    [theme.breakpoints.up('sm')]: {
      height: '1100px', // Height for small (sm) screens and up
    },
    [theme.breakpoints.up('md')]: {
      height: '2000px', // Height for medium (md) screens and up
    },
  },
  supermapIframe: {
    border: 0,
    height: '600px', // Default height for extra-small (XS) screens
    [theme.breakpoints.up('sm')]: {
      height: '800px', // Height for small (sm) screens and up
    },
    [theme.breakpoints.up('md')]: {
      height: '1800px', // Height for medium (md) screens and up
    },
  },
  imgOffice: {
    width: '100%',
    // [theme.breakpoints.down('xs')]: {
    //   width: '130px',
    // },
    // [theme.breakpoints.only('sm')]: {
    //   width: '150px',
    // },
  },
}));

// console.log(globalStyle);
export default function About() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <TitlePage title={t('เกี่ยวกับเรา')} />
      <Box>
        <Box mt={3} fontSize="1.5em" fontFamily="Kanit">
          {t('สำนักงานทรัพยากรน้ำแห่งชาติ')}
        </Box>
        <Box mt={1} mb={2}>
          <Typography variant="body1">
            {t('เป็นส่วนราชการสังกัดสำนักนายกรัฐมนตรี ตั้งขึ้นตามคำสั่งหัวหน้าคณะรักษาความสงบแห่งชาติ(คสช.) ที่ 46/2560  โดยอยู่ในบังคับบัญชาขึ้นตรงต่อนายกรัฐมนตรี เพื่อ บริหารจัดการน้ำของประเทศทั้งระบบ ให้มีเอกภาพเป็นหนึ่งเดียว ลดความซ้ำซ้อน ของหน่วยงานด้านน้ำที่มีอยู่กว่า 44 หน่วยงานในปัจจุบัน โดยทำหน้าที่ คือ')}
          </Typography>
        </Box>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md="auto">
              <img src={AboutOfficeImg} className={classes.imgOffice} alt="onwr-office" />
            </Grid>
            <Grid item xs={12} md>
              <ul>
                <li>
                  <Typography variant="body1">
                    {t('บูรณาการข้อมูล แผนงาน โครงการ งบประมาณ ตลอดจนการติดตามประเมินผลสัมฤทธิ์จากการปฏิบัติงานของหน่วยงานที่เกี่ยวข้องกับน้ำก่อนเสนอคณะกรรมการทรัพยากรน้ำแห่งชาติ(กนช.) และคณะรัฐมนตรีเห็นชอบ')}
                  </Typography>
                </li>
                <li>
                  <Typography>{t('ขับเคลื่อนยุทธศาสตร์ แผนแม่บท การบริหารจัดการน้ำของประเทศ ประกอบด้วย')}</Typography>
                </li>
                <Box mt={2}>
                  <Typography variant="body1">{t('1.การจัดการน้ำอุปโภคบริโภค')}</Typography>
                  <Typography variant="body1">{t('2.การสร้างความมั่นคงของน้ำภาคการผลิต (เกษตรและอุตสาหกรรม)')}</Typography>
                  <Typography variant="body1">{t('3.การจัดการน้ำท่วมและอุทกภัย')}</Typography>
                  <Typography variant="body1">{t('4.การอนุรักษ์ฟื้นฟูระบบนิเวศทรัพยากรน้ำ')}</Typography>
                  <Typography variant="body1">{t('5.การบริหารจัดการ ให้เป็นไปตามเป้าหมาย สอดคล้องกับยุทธศาสตร์ชาติ 20 ปี และแผนพัฒนาเศรษฐกิจและสังคมแห่งชาติ ฉบับที่ 13 ซึ่งมีการวางรากฐานมาจากการมีส่วนร่วมของประชาชน')}</Typography>
                </Box>
              </ul>
            </Grid>
            <Grid item xs={12}>
              <ul>
                <li>
                  <Typography variant="body1">
                    {t('ขับเคลื่อนแผนงาน แผนงานเร่งด่วน แผนปฏิบัติการ โครงการอันเนื่องมาจากพระราชดําริ และโครงการต่าง ๆ บริหารจัดการน้ำเชิงพื้นที่อย่างเป็นระบบ   ')}
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    {t('ดำเนินการบูรณาการข้อมูลสารสนเทศด้านน้ำ ที่มีเจ้าภาพกระจายในหลายหน่วยงาน โดยต้องการให้สามารถดึงข้อมูลมาใช้งานได้ทันที  เพื่อเป็นฐานข้อมูล  และสารสนเทศประกอบการตัดสินใจ ทั้งในภาวะปกติและภาวะวิกฤติ  ')}
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    {t('พัฒนาองค์ความรู้ เน้นการผสมผสานระหว่างศาสตร์พระราชา  ภูมิปัญญาท้องถิ่น และองค์ความรู้สากล  มาประยุกต์ใช้ให้เหมาะสมกับแนวทางการบริหารจัดการทรัพยากรน้ำของประเทศ')}
                  </Typography>
                </li>
                <li>
                  <Typography variant="body1">
                    {t('ขับเคลื่อนการบริหารจัดการน้ำในระดับภูมิภาค ผ่านสำนักงานทรัพยากรน้ำแห่งชาติภาค 1-4 ซึ่งจะทำให้สามารถเชื่อมโยงนโยบายไปสู่การปฏิบัติได้อย่างแท้จริงตรงตามเจตนารมณ์ที่ปรากฏในพระราชบัญญัติทรัพยากรน้ำ')}
                  </Typography>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Box mt={4} fontSize={20} fontFamily="Kanit">
              {t('ศูนย์อำนวยการน้ำแห่งชาติ')}
            </Box>
          </Grid>
          <Grid item xs={12} md="auto">
            <img src={NwccBanner} className={classes.imgOffice} alt="onwr-office" />
          </Grid>
          <Grid item xs={12} md>
            <Box mb={2} fontSize={18} fontFamily="Kanit">
              {t('หน้าที่ความรับผิดชอบ')}
            </Box>
            <Box mt={2}>
              <Typography variant="body1">{t('1.ศึกษา วิจัย วิเคราะห์ และคาดการณ์ข้อมูลอากาศ รวมทั้งพยากรณ์สถานการณ์น้ำเพื่อสนับสนุนการวางแผนบริหารจัดการทรัพยากรน้ำ')}</Typography>
              <Typography variant="body1">{t('2.ศึกษา วิจัย วิเคราะห์ ออกแบบ และพัฒนาระบบคลังข้อมูลบริหารจัดการทรัพยากรน้ำกำหนดมาตรฐานข้อมูลสารสนเทศทรัพยากรน้ำ และเชื่อมโยงแลกเปลี่ยนข้อมูลสารสนเทศทรัพยากรน้ำกับหน่วยงานที่เกี่ยวข้อง รวมทั้งบูรณาการการทำงานร่วมกันระหว่างหน่วยงานที่เกี่ยวข้อง เพื่อสนับสนุนการบริหารทรัพยากรน้ำและการตัดสินใจของ กนช. และคณะกรรมการลุ่มน้ำ')}</Typography>
              <Typography variant="body1">{t('3.เป็นศูนย์อำนวยการข้อมูลสารสนเทศทรัพยากรน้ำแห่งชาติ เพื่อติดตาม เฝ้าระวัง ป้องกัน และเตือนภัยสถานการณ์น้ำ')}</Typography>
              <Typography variant="body1">{t('4.ติดตามและจัดทำรายงานสถานการณ์น้ำของประเทศ')}</Typography>
              <Typography variant="body1">{t('5.ดำเนินการเกี่ยวกับการให้บริการและพัฒนาระบบเทคโนโลยีสารสนเทศของสำนักงาน')}</Typography>
              <Typography variant="body1">{t('6.จัดทำผังน้ำ และฐานข้อมูลต่างๆ ที่เกี่ยวข้องกับภูมิสารสนเทศผังน้ำ')}</Typography>
              <Typography variant="body1">{t('7.ให้คำปรึกษาและข้อเสนอแนะเกี่ยวกับการใช้ประโยชน์ที่ดินตามผังน้ำแก่หน่วยงานของรัฐและองค์กรปกครองส่วนท้องถิ่น')}</Typography>
              <Typography variant="body1">{t('8.ศึกษา วิเคราะห์ และจัดทำข้อมูลภูมิสารสนเทศทรัพยากรน้ำ เพื่อใช้ในการสื่อสาร การนำเสนอข้อมูล และสนับสนุนการบริหารทรัพยากรน้ำ')}</Typography>
              <Typography variant="body1">{t('9.ศึกษา วิเคราะห์ วิจัย และออกแบบการจัดทำฐานข้อมูลทะเบียนแหล่งน้ำ ทะเบียนผู้ใช้น้ำประเภทต่างๆ และทะเบียนองค์กรผู้ใช้น้ำ')}</Typography>
              <Typography variant="body1">{t('10.ศึกษา วิเคราะห์ และพัฒนาการถ่ายทอดเทคโนโลยีสารสนเทศทรัพยากรน้ำ เพื่อให้หน่วยงานของรัฐและองค์กรปกครองส่วนท้องถิ่นที่เกี่ยวข้องกับการบริหารทรัพยากรน้ำดำเนินงานให้เป็นไปตามมาตรฐานและข้อมูลสารสนเทศทรัพยากรน้ำเดียวกัน')}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box mt={5} mb={5} fontFamily="Kanit">
        <Box id="ntw" display="block" fontWeight={600} fontSize={26}>
          {t('สถิติการเข้าชม')}
        </Box>
        <Box display="flex" alignItems="center">
          <Box display="block" mr={3} width="auto">
            <Typography style={{ fontSize: 18, fontWeight: 600, fontFamily: 'Kanit' }} noWrap>
              {t('เว็บไซต์ ntw.onwr.go.th')}
            </Typography>
          </Box>
          <Hidden xsDown><Box style={{ borderBottom: '5px solid #9E9E9E', width: '100%' }} /></Hidden>
        </Box>
      </Box>
      <iframe
        src="https://lookerstudio.google.com/embed/reporting/eabcf7d7-47db-4233-91fe-c8a372490d44/page/4VDGB"
        style={{ height: '2210px' }}
        className={classes.ntwIframe}
        allowFullScreen
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        title="National Thaiwater Dashboard"
      />
    </div>
  );
}
